<template>
  <swiper dir="rtl" :slidesPerView="'auto'" :navigation="getNavigation(option)" :freeMode="true"
          :spaceBetween="15" @swiper="onSwiper">
    <a href="#pre-order-modal" id="test" rel="modal:open"></a>
    <swiper-slide v-for="(val, index) in option.values" :virtualIndex="index">
      <div
        v-if="isDisabled(option.id, val.id) && option.id === 24"
        @click="selectDisabled(val.id)"
        class="order-modal">
        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.15927 8.89899C6.15927 9.31143 5.93938 9.6271 5.58227 9.83343C5.22527 10.0397 4.78538 10.0397 4.42905 9.83343C4.07183 9.6271 3.85205 9.31143 3.85205 8.89899" fill="white"/>
          <path d="M5.00521 1.69754C5.31988 1.69754 5.57332 1.89154 5.57332 2.18987C5.57332 2.37765 5.57988 2.51776 5.69788 2.55365C6.70132 2.85665 7.34477 3.56687 7.34477 4.48921V6.03943C7.34477 6.74965 7.63532 6.89343 8.00099 7.1651C8.53054 7.55787 8.40966 8.37576 7.80199 8.37521H2.20865C1.60099 8.37576 1.4801 7.55787 2.00965 7.1651C2.37488 6.89343 2.66588 6.74965 2.66588 6.03943V4.48921C2.66588 3.56687 3.30932 2.85665 4.31277 2.55365C4.43043 2.51776 4.43732 2.37765 4.43732 2.18987C4.43743 1.89154 4.69099 1.69754 5.00521 1.69754Z" fill="white"/>
        </svg>
      </div>
      <div :class="getValueClass(option, val)" @click="onValueClick(option, val)">
<!--        <span v-if="option.id === 24 && !isMobile()" v-html="'גריפ ' + val.name"></span>
        <span v-else v-html="val.name"></span>-->
        <span v-html="val.name">
        </span>
      </div>
    </swiper-slide>
  </swiper>
  <div class="product__option__navs" :style="{visibility: isShowArrows ? 'visible' : 'hidden'}">
    <div class="product__option__navs__prev">
      <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.871167 20C0.631052 20.0004 0.436057 19.8061 0.435609 19.566C0.435405 19.4502 0.481382 19.3392 0.56335 19.2574L9.82135 10.0002L0.56335 0.743142C0.393341 0.573133 0.393341 0.297516 0.56335 0.127507C0.733358 -0.0425022 1.00898 -0.0425022 1.17898 0.127507L10.744 9.69247C10.9137 9.86224 10.9137 10.1374 10.744 10.3073L1.17898 19.8722C1.09742 19.954 0.98668 20 0.871167 20Z"
          fill="#E5E5E5"/>
      </svg>
    </div>
    <div class="product__option__navs__next">
      <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.0001 1.86927e-06C10.2402 -0.000446337 10.4352 0.193895 10.4356 0.434011C10.4358 0.549768 10.3898 0.660839 10.3079 0.742603L1.04986 9.99975L10.3079 19.2569C10.4779 19.4269 10.4779 19.7025 10.3079 19.8725C10.1379 20.0425 9.86224 20.0425 9.69223 19.8725L0.127265 10.3075C-0.0424586 10.1378 -0.0424586 9.86255 0.127265 9.69275L9.69223 0.127823C9.77379 0.0460185 9.88454 1.85917e-06 10.0001 1.86927e-06Z"
          fill="#019CDE"/>
      </svg>
    </div>
    <div id="pre-order-modal" class="modal">
        <div class="pre-order-modal__header">
          המוצר בעובי ידית זו אזל מהמלאי
        </div>
        <div class="pre-order-modal__body">
          <div class="modal-caption">
            להזכיר לי כאשר המוצר חוזר למלאי!
          </div>
          <input type="text" placeholder="כתובת אימייל" required="required" v-model="email" id="pre-order-email">
        </div>
        <div class="pre-order-modal__footer">
          <button class="btn btn-submit" @click="preOrder">
            להגדיר תזכורת
          </button>
        </div>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper.scss';
import SwiperCore, {
  Navigation,
  Virtual
} from 'swiper/core';
import {ref} from "vue";
import axios from "axios";

// install Swiper modules
SwiperCore.use([Navigation, Virtual]);

export default {
  name: "OptionSlider",
  props: {
    option: {},
    selected: {},
    isDisabled: {},
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props, {emit}) {
    const selectedDisabled = ref(null);
    const getNavigation = (option) => {
      return {
        nextEl: `.product__option[data-id="${option.id}"] .product__option__navs__next`,
        prevEl: `.product__option[data-id="${option.id}"] .product__option__navs__prev`,
      }
    }

    const getValueClass = (option, val) => {
      return {
        'disabled': props.isDisabled(option.id, val.id),
        'product__option__value': true,
        'active': props.selected[option.id] === val.id,
      }
    }

    const onValueClick = (option, val) => {
      if(!props.isDisabled(option.id, val.id)) {
        emit('click', {option, val})
      }
    }
    const isMobile = () => {
      console.log(window.innerWidth)
      return window.innerWidth < 768;
    }

    const isShowArrows = ref(true)
    const email = ref(null);

    const onSwiper = (swiper) => {
      if(swiper.virtualSize === swiper.width){
        isShowArrows.value = false
      }
    }
    const preOrder = () => {
      const grip = props.option.values.find(item => item.id === selectedDisabled.value).name??0
      let input = document.getElementById('pre-order-email');
      if(!email.value) {
        input.style.borderColor = 'red';
        return;
      }
      input.style.borderColor = '#C5C5C5';
      axios.get('/pre-order/' + email.value + '/' + grip + '/' + window.product.article).then((resp) => {
        document.getElementsByClassName('close-modal')[0].click();
        email.value = null;
      }).catch((err) => {
        document.getElementsByClassName('close-modal')[0].click();
      })
    }
    const selectDisabled = (val) => {
      selectedDisabled.value = val;
      let input = document.getElementById('pre-order-email');
      input.style.borderColor = '#C5C5C5';
      document.getElementById('test').click();
    }

    return {
      email,
      isShowArrows,
      selectedDisabled,
      isMobile,
      getNavigation,
      getValueClass,
      onValueClick,
      onSwiper,
      preOrder,
      selectDisabled
    }
  }
}
</script>
